/**
 * <voge-read-more>: clamps long text (collection SEO description) and adds a toggle.
 * The full text stays in the DOM; without JS nothing is clamped.
 */
class VogeReadMore extends HTMLElement {
  connectedCallback() {
    if (this.button) return;
    const body = this.querySelector('.voge-read-more__body');
    if (!body) return;

    this.setAttribute('data-clamped', '');
    // Nothing to hide: short texts stay unclamped and get no button.
    if (body.scrollHeight <= body.clientHeight + 4) {
      this.removeAttribute('data-clamped');
      return;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'voge-read-more__toggle';
    button.setAttribute('aria-expanded', 'false');
    if (body.id) button.setAttribute('aria-controls', body.id);
    button.textContent = this.dataset.more || 'Read more';
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      button.textContent = open ? this.dataset.more || 'Read more' : this.dataset.less || 'Show less';
      this.toggleAttribute('data-clamped', open);
    });
    this.button = button;
    this.append(button);

    // Open when the visitor follows the "Read more" link in the header (#collection-about).
    if (window.location.hash === '#collection-about') button.click();
    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#collection-about' && button.getAttribute('aria-expanded') === 'false') button.click();
    });
  }
}

if (!customElements.get('voge-read-more')) customElements.define('voge-read-more', VogeReadMore);
